import apiCallHandler from './apiCallHandler'
import api from './api'

export const getFile = (query, options) => {
  return apiCallHandler(() => api.get(`/fileuploads-service/download${query}`, options))
}
